import { render, staticRenderFns } from "./Frame.vue?vue&type=template&id=475d1b94&scoped=true"
import script from "./Frame.vue?vue&type=script&lang=js"
export * from "./Frame.vue?vue&type=script&lang=js"
import style0 from "./Frame.vue?vue&type=style&index=0&id=475d1b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475d1b94",
  null
  
)

export default component.exports